import { get } from '@bigyouth/base'
import emitter from '../utils/emitter'
import scrollManager from '../utils/scrollManager'
import { srHide, srShow } from '../utils/srVisibility'

export default {
  name: 'cart-add',

  ui: {
    modal: '[js-cart-add-modal]',
    'closeModal[]': '[js-cart-add-close-modal]',
  },

  events: [
    {
      target: 'closeModal',
      on: 'click',
      handle (e) {
        e.preventDefault()
        srHide(this.ui.modal)
        scrollManager.restart()
      },
    },
  ],

  componentDidMount () {
    // Move modal to modals layer
    const modalsLayer = get('.modals')
    modalsLayer.appendChild(this.ui.modal)

    emitter.on('cart_update', () => {
      srShow(this.ui.modal)
      scrollManager.stop()
    })
  },
}
